

import React, { useEffect, useContext, useState, useCallback } from "react";
import {
	Container,
	Row,
	Col,
	Form,
	Button,
	Card,
	Image,
	CloseButton,
	ListGroup,
	ButtonGroup,
	ToggleButton,
	InputGroup,
} from "react-bootstrap";
import axios from "axios";
import { useParams } from "react-router-dom";
import { AppContext } from "../context/appContext";
import { STORE_TIERS, SHAPE_OPTIONS } from "../utils/constants";
import Select from "react-select";
import { FaHome, FaStore, FaRegImage } from "react-icons/fa"; // Home + Store icons
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { Eye, EyeSlash } from "react-bootstrap-icons"; // install if not already


function BakeryCreation() {
	const [skipBakeryPull, setSkipBakeryPull] = useState(false);
	const navigate = useNavigate();
	const { userSub: userSubParam } = useParams();
	const { userSub: userSubContext, setUserSub, setGlobalLoading } = useContext(AppContext);
	const userSub = userSubParam ? userSubParam : userSubContext;
  const [userBakeryStores, setUserBakeryStores] = useState([]);
  const [bakeryName, setBakeryName] = useState("");
  const [bakeryLogoFile, setBakeryLogoFile] = useState(null);
  const [bakeryLogo, setBakeryLogo] = useState(null);
  const [bakeryLogoFilename, setBakeryLogoFilename] = useState(null);
  const [isBakeryLogoChanged, setIsBakeryLogoChanged] = useState(false);
  const [favCakeImgFile, setFavCakeImgFile] = useState(null);
  const [favCakeImg, setFavCakeImg] = useState(null);
  const [favCakeImgFilename, setFavCakeImgFilename] = useState(null);
	const [isFavCakeImgChanged, setIsFavCakeImgChanged] = useState(false);
  const [additionalNotes, setAdditionalNotes] = useState("");

  const [cakeFlavors, setCakeFlavors] = useState([]);
  const [icingFlavors, setIcingFlavors] = useState([]);
  const [cakeFillings, setCakeFillings] = useState([]);
  const [selectedTiers, setSelectedTiers] = useState([]);

  const [selectedShapes, setSelectedShapes] = useState([]);
  const [dietaryRestrictions, setDietaryRestrictions] = useState([]);
  const [products, setProducts] = useState([]);

  const [startingPrice, setStartingPrice] = useState("");
  const [delivery, setDelivery] = useState(false);
  const [deliveryPrice, setDeliveryPrice] = useState("");

  const [cakePhotoFiles, setCakePhotoFiles] = useState([]);
  const [cakePhotoUrls, setCakePhotoUrls] = useState([]);
  const GOOGLE_API_KEY = "AIzaSyD5V5pktlC4weXq6ZWH0FavTWY-MEsewiw"; // Replace with your actual key

  const [address, setAddress] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const [formStep, setFormStep] = useState(0); // 0 = Page 1, 1 = Page 2
  const [locationType, setLocationType] = useState("home"); // default to store or null

  const [bakerEmail, setEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const isUserHasBakeryStore = userBakeryStores?.length > 0;
  const { globalLoading } = useContext(AppContext);



  const isStep0Valid = bakeryName.trim() !== "" && products.length > 0 && (isUserHasBakeryStore || (bakerEmail.trim() !== "" && password.trim() !== ""));
	const isStep1Valid = address.trim() !== "" && locationType.trim() !== "";
	const isStep2Valid = (!!bakeryLogo) && (!!favCakeImg);



    // Function to fetch address suggestions from Google Places API (Fixed)
	const fetchPlaces = async (input) => {
		if (!input) {
		  setSuggestions([]);
		  return;
		}
	  
		const endpoint = `https://places.googleapis.com/v1/places:autocomplete?key=${GOOGLE_API_KEY}`;
		const requestBody = {
		  input: input,
		  languageCode: "en",
		  locationBias: {
			circle: {
			  center: {
				latitude: 29.7604, // Houston
				longitude: -95.3698,
			  },
			  radius: 50000,
			},
		  },
		};
	  
		try {
		  const response = await fetch(endpoint, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(requestBody),
		  });
	  
		  const data = await response.json();
	  
		  if (data?.suggestions?.length > 0) {
			setSuggestions(
			  data.suggestions
				.filter((s) => s?.placePrediction?.structuredFormat?.mainText?.text)
				.map((s) => ({
				  description:
					s.placePrediction.structuredFormat.mainText.text +
					", " +
					s.placePrediction.structuredFormat.secondaryText.text,
				  placeId: s.placePrediction.placeId,
				}))
			);
		  } else {
			setSuggestions([]);
		  }
		} catch (error) {
		  console.error("🚨 Error fetching places:", error);
		}
	  };
	  
  

	const tierOptions = STORE_TIERS.map((tier) => ({
		value: tier,
		label: `${tier} Tier${tier > 1 ? "s" : ""}`,
	  }));




  const getUserBakeryStores = useCallback(async () => {
		try {
			if (userSub) {
				setGlobalLoading(true);
				const response = await axios.get(
					`https://lucvle8pqe.execute-api.us-east-1.amazonaws.com/v1/getBakeries-dev?accountId=${userSub}`,
				);
				if (
					response?.data?.bakeryStores &&
					response?.data?.bakeryStores?.length > 0
				) {
					setUserBakeryStores(response?.data?.bakeryStores);
					setBakeryName(response?.data?.bakeryStores?.[0]?.bakeryName);
					setCakeFlavors(response?.data?.bakeryStores?.[0]?.cakeFlavors);
					setIcingFlavors(response?.data?.bakeryStores?.[0]?.icingFlavors);
					setCakeFillings(response?.data?.bakeryStores?.[0]?.cakeFillings);
					//setSelectedTiers(response?.data?.bakeryStores?.[0]?.selectedTiers);
					const savedTiers = response?.data?.bakeryStores?.[0]?.selectedTiers;
					if (savedTiers?.length) {
					const formattedTiers = STORE_TIERS.map((tier) => ({
						value: tier,
						label: `${tier} Tier${tier > 1 ? "s" : ""}`,
					}));
					const selected = formattedTiers.filter((opt) => savedTiers.includes(opt.value));
					setSelectedTiers(selected);
					}

					setSelectedShapes(response?.data?.bakeryStores?.[0]?.selectedShapes);
					setStartingPrice(response?.data?.bakeryStores?.[0]?.startingPrice);
					setDelivery(response?.data?.bakeryStores?.[0]?.delivery);
					setDeliveryPrice(response?.data?.bakeryStores?.[0]?.deliveryPrice);
					setAdditionalNotes(response?.data?.bakeryStores?.[0]?.additionalNotes);
					setProducts(response?.data?.bakeryStores?.[0]?.products || []);
					setAddress(response?.data?.bakeryStores?.[0]?.address || "");
					setLocationType(response?.data?.bakeryStores?.[0]?.locationType || "home");



					if (response?.data?.bakeryStores?.[0]?.bakeryLogo) {
						setBakeryLogoFilename(response?.data?.bakeryStores?.[0]?.bakeryLogo);
					}
					if (response?.data?.bakeryStores?.[0]?.bakeryLogoUrl) {
						setBakeryLogo(response?.data?.bakeryStores?.[0]?.bakeryLogoUrl);
					}

					if (response?.data?.bakeryStores?.[0]?.favCakeImg) {
						setFavCakeImgFilename(response?.data?.bakeryStores?.[0]?.favCakeImg);
					}
					if (response?.data?.bakeryStores?.[0]?.favCakeImgUrl) {
						setFavCakeImg(response?.data?.bakeryStores?.[0]?.favCakeImgUrl);
					}

				
				}
				console.log("Setting global loading to false once everything is loaded in BakeryCreation");
				console.log("current state of user having bakery store:", isUserHasBakeryStore);
				setGlobalLoading(false);
				console.log("GlobalLoading is now false in BakeryCreation");
			}
		} catch (error) {
			console.error(
				"Error submitting data:",
				error.response ? error.response.data : error.message,
			);
			alert("There was an error submitting your inquiry.");
			setGlobalLoading(false);
		}
	}, [setGlobalLoading, userSub]);

	useEffect(() => {
		if (!skipBakeryPull) {
			getUserBakeryStores();
		}
	}, [getUserBakeryStores, skipBakeryPull]);

	useEffect(() => {
		return () => {
			setSkipBakeryPull(false);
		};
	}, []);
	
	

	

  const handleSubmit = async (e) => {
		e.preventDefault();
		setGlobalLoading(true);

		let accountId = userSub;

		if(!isUserHasBakeryStore){
			console.log("creating an account")
			setSkipBakeryPull(true);
			// Step 0: Create the user in Cognito
			const formattedEmail = bakerEmail.toLowerCase();
			const signupResponse = await Auth.signUp({
			username: formattedEmail,
			password: password,
			attributes: { email: formattedEmail },
			});

			// Step 0.1: Extract Cognito sub (accountId)
			accountId = signupResponse.userSub;
			console.log("✅ Cognito sub (accountId):", accountId);

			// ✅ Step 0.15: Save to global context
			setUserSub(accountId);
			console.log("user sub set");

			// Step 0.5: Assign the user to the bakery group
			await axios.post("https://vffutpswql.execute-api.us-east-1.amazonaws.com/dev/assign-group", {
			username: formattedEmail,
			userType: "bakery",
			});
			console.log("posted to axios");

			setUserBakeryStores([{ bakeryName }]);
			console.log("set user bakery stores");
		}

		//step 1: update the database to create the bakery.
		let newBakeryLogoFilename = "";
		let newBakeryLogoUploadUrl = "";
		if (isBakeryLogoChanged && bakeryLogoFile?.type) {
			const ext = bakeryLogoFile?.type?.split("/")[1];
			const response = await axios.get(
				`https://gvw12pg013.execute-api.us-east-1.amazonaws.com/v1/uploadFile-dev?fileType=${bakeryName}_bakery_logo&ext=${ext}`,
			);
			newBakeryLogoFilename = response?.data?.filename;
			newBakeryLogoUploadUrl = response?.data?.uploadUrl;
			await axios.put(newBakeryLogoUploadUrl, bakeryLogoFile);
		}

		let newFavCakeImgFilename = "";
		let newFavCakeImgUploadUrl = "";
		if (isFavCakeImgChanged) {
			const ext = favCakeImgFile?.type?.split("/")[1];
			const response = await axios.get(
				`https://gvw12pg013.execute-api.us-east-1.amazonaws.com/v1/uploadFile-dev?fileType=${bakeryName}_fav_cake_img&ext=${ext}`,
			);
			newFavCakeImgFilename = response?.data?.filename;
			newFavCakeImgUploadUrl = response?.data?.uploadUrl;
			await axios.put(newFavCakeImgUploadUrl, favCakeImgFile);
		}

		const cakePhotoFilenames = [];
		for (let i = 0; i < cakePhotoFiles.length; i++) {
		const file = cakePhotoFiles[i];
		const ext = file.type?.split("/")[1];
		const res = await axios.get(
			`https://gvw12pg013.execute-api.us-east-1.amazonaws.com/v1/uploadFile-dev?fileType=${bakeryName}_cake_photo_${i + 1}&ext=${ext}`
		);
		await axios.put(res.data.uploadUrl, file);
		cakePhotoFilenames.push(res.data.filename);
		}
		console.log("setting up form data");

    const formData = {
			accountId,
			bakeryName,
			bakeryLogo: isBakeryLogoChanged
				? newBakeryLogoFilename
				: bakeryLogoFilename,
			favCakeImg: isFavCakeImgChanged
				? newFavCakeImgFilename
				: favCakeImgFilename,
			cakePhotoFilenames,
			cakeFlavors,
			icingFlavors,
			cakeFillings,
			selectedTiers,
			selectedShapes, 
			dietaryRestrictions, 
			products,
			additionalNotes,
			startingPrice,
			delivery,
			deliveryPrice: delivery ? deliveryPrice : null,
			locationType,
			address,
		};

    try {
		
      if (isUserHasBakeryStore) {
		console.log("new bakery - posting here");
        await axios.put("https://vffutpswql.execute-api.us-east-1.amazonaws.com/dev/bakery", formData);
      } else {
		console.log("updated bakery - posting here");
        await axios.post("https://vffutpswql.execute-api.us-east-1.amazonaws.com/dev/bakery", formData);
      }
	  		console.log("checking to see if user has a bakery store");
			console.log("value: of isUserHasBakeryStore: ", isUserHasBakeryStore);
			if (!isUserHasBakeryStore) {
				console.log(bakerEmail);
				navigate("/verify-account", { state: { email: bakerEmail } });
				return;
			} 

			console.log("updating a bakery, so setting global loading to false here");
			setGlobalLoading(false);

    } catch (error) {
      console.error("Error submitting data:", error);
      alert("Error submitting bakery information.");
	  console.log("setting global loading to false on error");
	  setGlobalLoading(false);
    }

  };

  return (

	<>
    {globalLoading && (
      <div className="page-loading-overlay">
        <div className="spinner-border" role="status" />
      </div>
    )}
	
			<Container>

				<Form onSubmit={handleSubmit}>

				<div className="form-contents-wrapper">
				<Col className="text-center mb-2">
						<h3 className="mb-1">
							{isUserHasBakeryStore ? "Update " : "Create "}
							{userSubParam ? "" : ""} Bakery Profile
						</h3>
					</Col>

					{formStep === 0 && (
						<>
							<Form.Group className="mb-3">
							<Form.Label>Bakery Name</Form.Label>
							<Form.Control
								type="text"
								value={bakeryName}
								onChange={(e) => setBakeryName(e.target.value)}
								required
							/>
							</Form.Group>
			
							{!isUserHasBakeryStore && (
  <>
							<Form.Group className="mb-3">
							<Form.Label>Email Address</Form.Label>
							<Form.Control
								type="email"
								value={bakerEmail}
								onChange={(e) => setEmail(e.target.value.toLowerCase())}
								placeholder="you@example.com"
								required
							/>
							<Form.Text className="text-muted">
								This is how customers and Cakery will contact you.
							</Form.Text>
							</Form.Group>
							<Form.Group className="mb-3" controlId="password">
							<Form.Label>Password</Form.Label>
							<InputGroup>
								<Form.Control
								type={showPassword ? "text" : "password"}
								placeholder="Enter your password"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								required
								/>
								<InputGroup.Text
								onClick={() => setShowPassword(!showPassword)}
								style={{ cursor: "pointer", background: "white", borderLeft: "none" }}
								>
								{showPassword ? <EyeSlash /> : <Eye />}
								</InputGroup.Text>
							</InputGroup>
							</Form.Group>
							</>
)}

							<Form.Group className="mb-4">
									<Form.Label>Product(s) Offered</Form.Label>
									<Select
										options={[
										{ value: "cake", label: "Cake" },
										{ value: "cake pops", label: "Cake Pops" },
										{ value: "cupcakes", label: "Cupcakes" },
										{ value: "cookies", label: "Cookies" },
										{ value: "cinnamon rolls", label: "Cinnamon Rolls" },
										]}
										isMulti
										value={products.map((p) => ({ value: p, label: p.charAt(0).toUpperCase() + p.slice(1) }))}
										onChange={(selected) => setProducts(selected.map((option) => option.value))}
										className="basic-multi-select"
										classNamePrefix="select"
										placeholder="Select products..."
									/>
									<small className="text-muted">
									What product(s) does your bakery offer? When users search for these, we’ll make sure your bakery appears in the results.
									</small>

									</Form.Group>
								
									<div className="d-flex align-items-center justify-content-between w-100 mt-4">
									{/* Back button — hidden on first step */}
									<div style={{ width: "90px" }} /> {/* placeholder to keep layout aligned */}

									{/* Progress Bar & Step Text */}
									<div className="text-center cupcake-progress-inline d-flex flex-column align-items-center flex-grow-1">
										<div className="d-flex gap-2 justify-content-center">
										{[0, 1, 2].map((i) => (
											<img
											key={i}
											src={i <= formStep ? "/cupcake-full.png" : "/cupcake-empty.png"}
											alt={`Step ${i + 1}`}
											className="cupcake-step"
											style={{ height: "28px" }}
											/>
										))}
										</div>
										<div className="text-muted mt-1" style={{ fontSize: "14px" }}>
										Step {formStep + 1} of 3
										</div>
									</div>

									{/* Next button */}
									<Button
										className="next-button button-with-icon"
										disabled={!isStep0Valid}
										onClick={() => setFormStep(1)}
									>
										Next →
									</Button>
									</div>

									
						</>
						)}

						{/* ---- PAGE 2 ---- */}
						{formStep === 1 && (
						<>
						{bakeryName && (
						<div className="text-center mb-4 bakery-name-animate">
							<h2 className="bakery-name-header">{bakeryName}</h2>
						</div>
						)}
								<Form.Group className="position-relative">
									<Form.Label className="fw-bold">Location Type</Form.Label>
									<Form.Text className="text-muted mt-1 d-block">
										Is this a storefront address or your home bakery? This helps us describe your business accurately to customers.
									</Form.Text>
									<br></br>
									<div className="d-flex gap-4 w-100">
										<div
										className={`icon-radio flex-fill ${locationType === "home" ? "selected" : ""}`}
										onClick={() => setLocationType("home")}
										>
										<FaHome className="icon" />
										<div className="label">Home Bakery</div>
										</div>
										<div
										className={`icon-radio flex-fill ${locationType === "store" ? "selected" : ""}`}
										onClick={() => setLocationType("store")}
										>
										<FaStore className="icon" />
										<div className="label">Store Location</div>
										</div>
									</div>
									
									</Form.Group>
									<br></br>
									<Form.Group className="position-relative">
									<Form.Label className="fw-bold">Bakery Address</Form.Label>
									<Form.Control
										type="text"
										value={address}
										onChange={(e) => {
										setAddress(e.target.value);
										fetchPlaces(e.target.value);
										}}
										placeholder="123 Cakery Dr, Houston, TX..."
									/>
									
									{suggestions.length > 0 && (
										<ListGroup className="shadow-sm position-absolute bg-white z-3">
										{suggestions.map((suggestion, index) => (
											<ListGroup.Item
											key={index}
											action
											onClick={() => {
												setAddress(suggestion.description);
												setSuggestions([]);
											}}
											>
											{suggestion.description}
											</ListGroup.Item>
										))}
										</ListGroup>
									)}
									</Form.Group>
									{locationType === "home" && (
									<small className="text-muted">
										We won't share your home address. We'll just use it to match your bakery with customers nearby.
									</small>
									)}

									<br></br>
							<br></br>
							
							<div className="d-flex align-items-center justify-content-between w-100 mt-4">
							{/* Back Button */}
							<Button className="back-button" onClick={() => setFormStep(formStep - 1)}>
								← Back
							</Button>

							{/* Progress Bar + Step Text */}
							<div className="text-center cupcake-progress-inline d-flex flex-column align-items-center flex-grow-1">
								<div className="d-flex gap-2 justify-content-center">
								{[0, 1, 2].map((i) => (
									<img
									key={i}
									src={i <= formStep ? "/cupcake-full.png" : "/cupcake-empty.png"}
									alt={`Step ${i + 1}`}
									className="cupcake-step"
									style={{ height: "28px" }}
									/>
								))}
								</div>
								<div className="text-muted mt-1" style={{ fontSize: "14px" }}>
								Step {formStep + 1} of 3
								</div>
							</div>

							{/* Next / Submit Button */}
							<Button
								className="next-button button-with-icon"
								type={formStep === 2 ? "submit" : "button"}
								onClick={() => {
								if (formStep < 2) setFormStep(formStep + 1);
								}}
								disabled={
								(formStep === 0 && !isStep0Valid) ||
								(formStep === 1 && !isStep1Valid) ||
								(formStep === 2 && !isStep2Valid)
								}
							>
								{formStep === 2 ? "Submit" : "Next →"}
							</Button>
							</div>




						</>
						)}

								

						{/* ---- PAGE 3 ---- */}
						{formStep === 2 && (
						<>
							{bakeryName && (
						<div className="text-center mb-4 ">
							<h2 className="bakery-name-header">{bakeryName}</h2>
						</div>
						)}
							<Form.Group className="mb-5 text-center">
							<Form.Label className="fw-bold d-block">Store Logo</Form.Label>

							<div className="d-flex justify-content-center">
								<div className="image-upload-container">
								{bakeryLogo ? (
									<div className="image-wrapper">
									<Image
										src={bakeryLogo}
										alt="Bakery Logo"
										className="preview-img"
									/>
									<CloseButton
										onClick={() => setBakeryLogo(null)}
										className="close-btn"
									/>
									</div>
								) : (
									<div
										className="upload-frame"
										onClick={() => document.getElementById("bakeryLogoInput").click()}
										>
										<img
											src="/cakeryLogoGray.png"
											alt="Upload Prompt"
											className="upload-placeholder-img"
										/>
										<div className="upload-text">Click to upload logo</div>
										<Form.Control
											type="file"
											id="bakeryLogoInput"
											accept="image/*"
											onChange={(e) => {
											setBakeryLogoFile(e.target.files[0]);
											setBakeryLogo(URL.createObjectURL(e.target.files[0]));
											setIsBakeryLogoChanged(true);
											}}
											style={{ display: "none" }}
											required
										/>
										</div>

										)}

										<Form.Control
											type="file"
											id="bakeryLogoInput"
											accept="image/*"
											onChange={(e) => {
											setBakeryLogoFile(e.target.files[0]);
											setBakeryLogo(URL.createObjectURL(e.target.files[0]));
											setIsBakeryLogoChanged(true);
											}}
											style={{ display: "none" }}
										/>
										</div>
									</div>
									</Form.Group>

									<Form.Group className="mb-5 text-center">
							<Form.Label className="fw-bold mt-4 d-block">Favorite Baked Goods Image</Form.Label>
							<div className="d-flex justify-content-center">
								<div className="image-upload-container">
								{favCakeImg ? (
									<div className="image-wrapper">
									<Image src={favCakeImg} alt="Favorite Cake" className="preview-img" />
									<CloseButton onClick={() => setFavCakeImg(null)} className="close-btn" />
									</div>
								) : (
									<div
									className="upload-frame"
									onClick={() => document.getElementById("favCakeInput").click()}
									>
									<img
										src="/favoriteCakePhoto.png"
										alt="Upload Favorite"
										className="upload-placeholder-img"
										style={{ width: "70%", maxWidth: "200px", height: "200px", objectFit: "cover" }}
									/>
									<div className="upload-text">Click to upload a photo of a dessert you've made!</div>
									<Form.Control
										type="file"
										id="favCakeInput"
										accept="image/*"
										onChange={(e) => {
										setFavCakeImgFile(e.target.files[0]);
										setFavCakeImg(URL.createObjectURL(e.target.files[0]));
										setIsFavCakeImgChanged(true);
										}}
										style={{ display: "none" }}
										required
									/>
									</div>
								)}
								</div>
							</div>
							<small className="text-muted d-block mt-2">
								This image will appear in your thumbnail view when customers search for you.
							</small>
							</Form.Group>



							<div className="d-flex align-items-center justify-content-between w-100 mt-4">
							{/* Back button */}
							<Button className="back-button" onClick={() => setFormStep(1)}>
								← Back
							</Button>

							{/* Progress Bar & Step Text */}
							<div className="text-center cupcake-progress-inline d-flex flex-column align-items-center flex-grow-1">
								<div className="d-flex gap-2 justify-content-center">
								{[0, 1, 2].map((i) => (
									<img
									key={i}
									src={i <= formStep ? "/cupcake-full.png" : "/cupcake-empty.png"}
									alt={`Step ${i + 1}`}
									className="cupcake-step"
									style={{ height: "28px" }}
									/>
								))}
								</div>
								<div className="text-muted mt-1" style={{ fontSize: "14px" }}>
								Step {formStep + 1} of 3
								</div>
							</div>

							{/* Submit button */}
							<Button
								className="next-button button-with-icon"
								type="submit"
								disabled={!isStep2Valid}
							>
								{isUserHasBakeryStore ? "Update" : "Submit"}
							</Button>
							</div>


						</>
					
						)}

								




									
							
						<br></br>
						
					</div>
				</Form>
				
			
			</Container>
			</>
		);
}

export default BakeryCreation;
